import { NgTemplateOutlet } from '@angular/common';
import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { AuditFormat } from './audit-format';
import { prettyJson, readableRecordId } from './audit-query';
import { AuditChange, AuditFieldChange } from './audit.models';

/** Detail panel of a record change: who, when, which record, every changed field before / after */
@Component({
  selector: 'iu-audit-change-detail',
  standalone: true,
  imports: [TranslateModule, NgTemplateOutlet],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './audit-change-detail.component.html',
  styleUrl: './audit-detail.scss',
})
export class AuditChangeDetailComponent {
  readonly change = input<AuditChange | null>(null);
  readonly loading = input(false);
  readonly error = input<string | null>(null);
  readonly fmt = input.required<AuditFormat>();

  readonly closed = output<void>();
  readonly retry = output<void>();
  readonly openRecord = output<AuditChange>();
  readonly filterRecord = output<AuditChange>();
  readonly filterSession = output<AuditChange>();
  readonly filterUser = output<AuditChange>();

  pretty = prettyJson;
  record = readableRecordId;

  opKey(type: string): string {
    return ['I', 'U', 'D', 'STUDIO'].includes(type) ? `audit.operation.${type}` : 'audit.operation.other';
  }

  /** value as shown: local dates, else the text (null: empty); Yes / No through boolLabel */
  display(field: AuditFieldChange, value: string | null): string | null {
    if (value === null || value === undefined || value === '') return null;
    if (field.kind === 'date') return this.fmt().date(value) || value;
    if (field.kind === 'datetime') return this.fmt().dateTime(value) || value;
    return value;
  }

  boolLabel(field: AuditFieldChange, value: string | null): string | null {
    if (field.kind !== 'bool' || value === null) return null;
    return value === 'Y' || value === 'true' ? 'audit.yes' : value === 'N' || value === 'false' ? 'audit.no' : null;
  }
}
